import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FileDropzoneComponent } from '@shared/components/file-dropzone/file-dropzone.component';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { ArquivoImportacao } from '../../arquivo-importacao';
import { TAMANHO_MAXIMO_BYTES } from '../../importar-xml-nota-fiscal-entrada.constants';

@Component({
  selector: 'app-importar-xml-arquivo-step',
  standalone: true,
  imports: [CommonModule, MatIconModule, FileDropzoneComponent],
  templateUrl: './importar-xml-arquivo-step.component.html',
  styleUrls: ['./importar-xml-arquivo-step.component.css'],
})
export class ImportarXmlArquivoStepComponent {
  @Input() arquivo: ArquivoImportacao | null = null;
  @Output() arquivoSelecionado = new EventEmitter<File>();

  constructor(private alertService: AlertService) {}

  onFilesSelected(files: FileList): void {
    const file = files[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.xml')) {
      this.alertService.show('Arquivo recusado', `"${file.name}" não é um arquivo .xml.`, AlertType.warning);
      return;
    }
    if (file.size > TAMANHO_MAXIMO_BYTES) {
      this.alertService.show('Arquivo recusado', `"${file.name}" excede o limite de 10 MB.`, AlertType.warning);
      return;
    }
    this.arquivoSelecionado.emit(file);
  }

  onArquivoSubstituido(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) this.onFilesSelected(input.files);
    input.value = '';
  }

  tamanhoArquivo(): string {
    if (!this.arquivo) return '';

    const tamanhoEmKb = this.arquivo.file.size / 1024;
    const unidade = tamanhoEmKb >= 1024 ? 'MB' : 'KB';
    const valor = tamanhoEmKb >= 1024 ? tamanhoEmKb / 1024 : tamanhoEmKb;
    return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(valor)} ${unidade}`;
  }
}
